module.exports = __webpack_public_path__ + "img/herb-thyme-190x100.6a881c10.jpg";